import { createSelector } from "reselect";
import { State as RootState } from 'store/types';
import { State } from './reducers';

const rootSelector = (state: RootState): State => state.focus.feed;

export default {
	getBrandSync: createSelector(rootSelector, state => state.brand_sync)
};
